import { render, staticRenderFns } from "./GameTutorialTesting.vue?vue&type=template&id=130b5ca5&"
import script from "./GameTutorialTesting.vue?vue&type=script&lang=js&"
export * from "./GameTutorialTesting.vue?vue&type=script&lang=js&"
import style0 from "./GameTutorialTesting.vue?vue&type=style&index=0&id=130b5ca5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports